<template>
    <transition  >
    <div class="container-fluid ">
        <div class="row">
                <div class="col-12">
                    <div class="page-title-box">
                        <div class="page-title-right float-left">
                            <ol class="breadcrumb m-0"> 
                                <li class="breadcrumb-item active">All Patient </li>
                                <li class="breadcrumb-item"><a href="javascript: void(0);">All Patient List</a></li>
                                
                            </ol>
                        </div>
                        <div class="page-title-right float-right "> 
                            <!-- <button type="button" class="btn btn-success float-right" style="margin-left: 7px;" @click="toggleImportModal">
                                <i class="fas fa-plus"></i> Bulk Add Patient
                            </button>
                            <button type="button" class="btn btn-primary float-right" @click="toggleModal">
                              Add New
                            </button> -->
                        </div>
                    </div>
                </div>
            </div>  
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">   
                            <Datatable 
                                :columns="columns" 
                                :sortKey="tableData.sortKey"  
                                @sort="sortBy" 
                                v-if="!loading">
                                <template #header > 
                                    <div class="tableFilters" style="margin-bottom: 10px;">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="control" style="float: left;">
                                                    <span style="float: left; margin-right: 10px; padding: 7px 0px;">Show </span>
                                                    <div class="select" style="float: left;">
                                                        <select class="form-select" v-model="tableData.length" @change="getAllPatientList()"> 
                                                            <option value="10" selected="selected">10</option>
                                                            <option value="25">25</option>
                                                            <option value="50">50</option>
                                                            <option value="100">100</option>
                                                            <option value="500">500</option>
                                                            <option :value="pagination.total">All</option>
                                                        </select>
                                                    </div>
                                                    <span style="float: left; margin-left: 10px; padding: 7px 0px;"> Entries</span>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-2">
                                                
                                            </div>
                                            <div class="col-md-4">
                                                <input type="text" class="form-control" style="float: right;" v-model="tableData.search" placeholder="Search..." @input="getAllPatientList()">
                                            </div>
                                        </div>
                                    </div>   
                                </template> 
                                <template #body >                            
                                    <tbody v-if="patients.length > 0">
                                        <tr class="" v-for="(item, i) in patients" :key="i">
                                            <td>{{ i + 1 }} </td> 
                                            <td>{{ item.patients ? item.patients.name : item.patient_name }} </td> 
                                            <td>{{ item.patients ? item.patients.phone : item.patient_phone }} </td>
                                            <td>{{ item.patients ? item.patients.age : item.patient_age }} </td>
                                            <td>
                                                <div class="action-btns text-center">
                                                    <!-- item-->
                                                    <a href="javascript:void(0);" class="btn btn-sm btn-primary" title="Prescription View" @click="prescriptionView(item)">
                                                        <i class="mdi mdi-file-document-outline"></i>
                                                    </a> 
                                                    <!-- <a href="javascript:void(0);" class="btn btn-sm btn-info" title="Patient View" @click="patientInfoView(item)"> -->
                                                    <!-- <a href="javascript:void(0);" class="btn btn-sm btn-info" title="Patient View">
                                                        <i class="mdi mdi-eye-outline"></i>
                                                    </a>  -->
                                                    <a href="javascript:void(0);" class="btn btn-sm btn-warning" title="Patient Details" @click="patientDetails(item.patient_id)">
                                                        <i class="mdi mdi-view-list-outline"></i>
                                                    </a>
                                                    <!-- item-->
                                                </div>  
                                            </td>
                                        </tr>
                                    </tbody> 
                                    <tbody v-else>
                                        <tr>
                                            <td colspan="6"> No Data Available Here!</td>
                                        </tr>
                                    </tbody>
                                </template> 
                                <template #footer>
                                    <Pagination 
                                        :pagination="pagination"  
                                        :language="lang"
                                        @onChangePage="setPage" > 
                                    </Pagination> 
                                </template> 
                            </Datatable>


                            <div class="tab-pane show active" v-if="loading">
                                <div class="row"> 
                                    <div class="col-md-5">  
                                    </div>
                                    <div class=" col-md-2"> 
                                        <img src="../../../assets/image/loading.gif" alt="Loading..." style="width:130px">
                                    </div>
                                    <div class="col-md-5">  
                                    </div>
                                </div>
                            </div> 
                        </div>
                    </div>
                </div>
            </div> 
            
            <!-- Prescription view Modal -->
            <Modal @close="prescriptionViewModal()" :modalActive="showModal">
                <div class="modal-content scrollbar-width-thin prescription-view-modal">
                    <div class="modal-header"> 
                        <h5 class="">Prescription View</h5>
                        <button @click="prescriptionViewModal" type="button" class="btn btn-danger"><i class="mdi mdi-close"></i></button>
                    </div> 
                    <div class="modal-body" v-if="prescription">  
                        <div class="row">
                            <div class="col-12">
                                <div class="card">
                                    <div id="prescriptionArea" class="card-body prescription">
                                        <!-- Prescription Body -->
                                        <div class="prescription_body">
                                            <!-- Patient Details -->
                                            <div class="row">
                                                <div class="col-md-12 table-patient-info">
                                                    <table class="table patient_info">
                                                        <tbody>
                                                            <tr>
                                                                <td width="50%" class="p_name">{{ prescription.patient.name }}</td>
                                                                <td width="20%" class="p_age" style="font-size: 13px; padding-top: 12px; word-spacing: -2px;">{{ prescription.age }} </td>
                                                                <td width="15%" class="p_weight">{{ prescription.weight }}</td>
                                                                <td width="15%" class="p_date">{{ prescription.prescription_view_date }}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>

                                            <!-- Medicines & Test Details -->
                                            <div class="row">
                                                <div class="col-md-5">
                                                    <div class="left-container">
                                                        <div class="test_details">
                                                            <div class="basic_test_info">
                                                                <ul>
                                                                    <li>Blood Pressure: <span>{{ (prescription.blood_pressure) ? prescription.blood_pressure : '---' }}</span></li>
                                                                    <li>Pulse Rate: <span>{{ (prescription.pulse_rate) ? prescription.pulse_rate : '---' }}</span></li>
                                                                    <li>Temperature: <span>{{ (prescription.temperature) ? prescription.temperature : '---' }}</span></li>
                                                                    <li>Blood Sugar: <span>{{ (prescription.diabetic) ? prescription.diabetic : '---' }}</span></li>
                                                                    <li>Diagnosis: <span>{{ (prescription.problem_description) ? prescription.problem_description : '---' }}</span></li>
                                                                </ul>
                                                            </div>
                                                            <div class="examines">
                                                                <ul v-if="prescription.test_items">
                                                                    <li v-for="(test_item ,index) in prescription.test_items" :key="index">{{ test_item.name }}</li>     
                                                                </ul>
                                                            </div>                                                    
                                                            <div class="advices">
                                                                <ul v-if="prescription_advices.length > 0">
                                                                    <li v-for="(advice, i) in prescription_advices" :key="i">{{ (advice) ? advice : '' }}</li>
                                                                </ul>
                                                            </div>

                                                            <div class="next_visit">
                                                                <p><span class="visit_days">{{ prescription.next_visit ?? '' }}</span></p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-7 pl-0">                                                    
                                                    <div class="medicine_details">
                                                        <ul v-if="prescription.medicine_items">
                                                            <li v-for="(medicine_item ,index) in prescription.medicine_items" :key="index">
                                                                <h5>{{ index + 1}}. {{ medicine_item.name }}</h5>
                                                                <p>
                                                                    <span>Dosage: {{ medicine_item.dose_interval }}</span> 
                                                                    <!-- <span style="padding-left: 10px" v-if="medicine_item.cat_name == 'Syrup'"><i>---</i> {{ medicine_item.dosage+ ' spoon' }}</span>
                                                                    <span style="padding-left: 10px" v-else-if="medicine_item.cat_name == 'Tablet'"><i>---</i> {{ medicine_item.dosage+ ' pcs'}}</span>
                                                                    <span style="padding-left: 10px" v-else-if="medicine_item.cat_name == 'Capsul'"><i>---</i> {{ medicine_item.dosage+ ' pcs'}}</span> -->
                                                                    <span style="padding-left: 10px"><i>---</i> {{ medicine_item.dose_time }}</span>
                                                                    <span style="padding-left: 10px" v-if="medicine_item.dose_duration != ''"><i>---</i> {{ medicine_item.dose_duration }}</span>
                                                                </p>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> <!-- end card-body-->
                                </div> <!-- end card-->
                            </div> <!-- end col-->  
                        </div>
                    </div>
                    <div class="modal-footer"> 
                        <button type="button" class="btn btn-danger" @click="prescriptionViewModal()">
                            Close
                        </button> 
                        <button type="button" class="btn btn-primary" @click="printPrescription()">
                            Print
                        </button> 
                    </div>
                </div>
            </Modal>

        </div>
    </transition>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Modal from "../../helper/Modal";
import Datatable from '@/components/Datatable.vue';
import Pagination from '@/components/Pagination.vue';
import { ref, onMounted, reactive } from "vue";
import Form from 'vform'
import axios from 'axios';
export default {
    name: 'AllPatients',
    components: {
        Modal,
        Datatable,
        Pagination,
    },
    props:{
        language: {
          type: Object,
          default: () => {
            return {
              lengthMenu: null,
              info: null,
              zeroRecords: null, 
              search: null
            }
          },
        },
    },
    data() {
        return {
            loading: true,
            isSubmit: false,
            showModal: false,
            editMode:false,
            disabled: false,
            modalActive:false,
            errors: {},
            imagePreview: '',
            btn:'Create',
            items: [],
            patients: [],
            companies: [],
            prescription: '',
            prescription_advices: [],
            multiclasses: { 
                clear: '',
                clearIcon: '', 
            },            
            columns: [ 
                {
                    label: 'SL',
                    name: '',  
                    isSearch: false, 
                    isAction: true,         
                    width: '5%'
                },   
                {
                    label: 'Name',
                    name: 'patient_name',
                    width: '20%'
                },
                {
                    label: 'Phone',
                    name: 'patient_phone',
                    width: '20%'
                },
                {
                    label: 'Age',
                    name: 'patient_age',
                    width: '30%'
                },
                {
                    label: 'Actions',            
                    name: '',
                    isSearch: false, 
                    isAction: true,
                    width: '15%',

                }
            ],  
            tableData: {
                draw: 0,
                length: 10,
                search: '',
                column: 1,
                dir: 'asc',
                sortKey: 'appointment_id', 
            }, 
            lang: {
                lengthMenu: this.$props.language.lengthMenu ? this.$props.language.lengthMenu : 'Show_MENU_entries',
                info: this.$props.language.info ? this.$props.language.info : 'Showing_FROM_to_TO_of_TOTAL_entries',
                zeroRecords: this.$props.language.zeroRecords ? this.$props.language.zeroRecords : 'No data available in table.', 
                search: this.$props.language.search ? this.$props.language.search : 'Search'
            },
            pagination: {
                lastPage: '',
                currentPage: '',
                total: '',
                lastPageUrl: '',
                nextPageUrl: '',
                prevPageUrl: '',
                from: '',
                to: '',
                links:[],
            }

        };
    },
    created() { 
        this.getAllPatientList();
        // this.fetchCompany()
        // this.fetchDistrict()
    },
    methods: { 
        forceRerender(index) {
            // Remove my-component from the DOM
            this.renderOptionComponent = false;

            this.$nextTick(() => {
                // Add the component back in
                this.renderOptionComponent = true;
            });
        },

        toggleModal: function() {
            this.modalActive = !this.modalActive;   
            if(!this.modalActive){
                this.editMode = false;
                this.btn='Create';
            } 
            this.errors = '';
            this.isSubmit = false;
            this.form.reset();  
        },
         
        prescriptionViewModal: function() {  
            this.showModal = !this.showModal;
        },

        print(document_id, style_link) { 

            const options = {
                name: '_blank',
                specs: ['fullscreen=yes', 'titlebar=yes', 'scrollbars=yes'],
                styles: [ 
                    this.baseUrlPrintCSS+'/assets/css/bootstrap-print.min.css',
                    style_link
                ],
            };
                
            this.$htmlToPaper(document_id, options);

        },

        fetchCompany() { 
            axios.get(this.apiUrl+'/companies', this.headerjson)
            .then((res) => {
                this.companies = res.data.data; 
            })
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            }); 
        },

        prescriptionView: function(item, type='view') {                 
            
            let formData = new FormData();
            if(type == 'submit') {
                var appointment_id = item.appointment_id
            }else {
                appointment_id = item.id
            }

            formData.append("appointment_id", appointment_id);
            axios.post(this.apiUrl+'/hm/prescriptions/get-by-id', formData, this.headers)
            .then(res => {            
                this.showModal = !this.showModal;
                if(res.status == 200){ 
                    this.prescription = res.data.data; 
                    if(res.data.data.advice != 'null' || res.data.data.advice != '') {
                        this.prescription_advices = res.data.data.advice.split(";");
                    }
                    if(type == 'submit') {
                        setTimeout(()=>{ this.printPrescription(); }, 1000);
                    }
                } else {
                    this.$toast.error(res.message);
                }
            }).catch(err => {  
                this.$toast.error(err.response.data.message);
                if(err.response.status == 422){
                    this.errors = err.response.data.errors;
                }
            })
        },

        printPrescription: function() {
            let printStyleLink = this.baseUrlPrintCSS+'/assets/css/print_prescription_pad.css';
            this.print('prescriptionArea', printStyleLink);
        },

        // Patient Details
        patientDetails(patient_id) {
            let details_route = this.$router.resolve({name: 'all-patient-details', params: {id: patient_id}});
            window.open(details_route.href, '_blank');
        },

        validation: function (...fiels){ 
            var obj = new Object(); 
            var validate = false;
            for (var k in fiels){     // Loop through the object  
                for (var j in this.form){  
                    if((j==fiels[k]) && (!this.form[j])) {  
                        obj[fiels[k]] = fiels[k].replace("_", " ")+' field is required';  // Delete obj[key]; 
                        this.errors = {...this.errors, ...obj};
                    }else{
                        validate = false;
                    }
                }              
            }  
            // var obj = new Object();
            // obj[fiels] = fiels.replace("_", " ")+' field is required';  
            // this.errors = {...this.errors, ...obj}; 
        },
        onkeyPress: function(field) { 
            for (var k in this.errors){     // Loop through the object
                if(k==field){      // If the current key contains the string we're looking for 
                    delete this.errors[k];  // Delete obj[key];
                }
            }  
        },

        // For Pagination 
        getAllPatientList(url = this.apiUrl+'/hm/patients/all') {
            this.tableData.draw++;
            axios.get(url, {params:this.tableData,  headers:this.headerparams})
            .then((response) => {
                let data = response.data.data; 
                if(this.tableData.draw = data.draw) {
                    this.patients = data.data.data;
                    this.configPagination(data.data);
                }
            })
            .catch(errors => {
                this.$toast.error(errors.response.data.message);
            })
            .finally((fres) => {
                this.loading = false;
            });
        },

        configPagination(data){
            this.pagination.lastPage = data.last_page;
            this.pagination.currentPage = data.current_page;
            this.pagination.total   = data.total ? data.total : 0;
            this.pagination.lastPageUrl = data.last_page_url;
            this.pagination.nextPageUrl = data.next_page_url;
            this.pagination.prevPageUrl = data.prev_page_url;
            this.pagination.from = data.from ? data.from : 0;
            this.pagination.to = data.to ? data.to : 0;  
            this.pagination.links = data.links;
        },

        sortBy(key,sortable) {
            this.tableData.sortKey = key;
            //this.sortOrders[key] = this.sortOrders[key] * -1;
            this.tableData.column = this.getIndex(this.columns, 'name', key);
            this.tableData.dir = sortable; ///this.sortOrders[key] === 1 ? 'asc' : 'desc'; 
            this.getAllPatientList();
        },
        setPage(data){  
            this.getAllPatientList(data.url); 
        },
        getIndex(array, key, value) {
            return array.findIndex(i => i[key] == value)
        },


    },
    destroyed() {},
    mounted() {
        window.scrollTo(0, 0);
    },
    computed: {}
}
</script>
<style scoped>
.modal-content.scrollbar-width-thin {
    border: none !important;
    width: 900px
}

#prescriptionModal.modal-content.scrollbar-width-thin {
    border: none !important;
    width: 1068px;
}

label {
    display: inline-block;
    margin: 0px 0px 4px 2px;
    float: left;
}

.invalid-feedback {
    display: block;
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #dc3545;
    text-align: left;
}


/* Prescription CSS */
#prescriptionArea {
    background: url('/assets/pad_prescriptions/outdoor_prescription.jpg') no-repeat;
    background-size: 100% 100%;
    /* font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif !important; */
    font-family: Tahoma, "Trebuchet MS", sans-serif !important;
    /* border: 1px solid #a19b9b; */
    padding: 0;
}

#prescriptionArea h1, h2, h3, h4, h5, h6  {
  font-family: Tahoma, "Trebuchet MS", sans-serif !important;
}

.table.patient_info {
    margin-top: 216px;
    margin-bottom: 0;
    padding: 15px;
    color: #000000;
}
.table.patient_info tr td { 
    border: none;
    padding: 10px 15px;
    font-size: 15px;
    font-weight: 400;
}

.table.patient_info .p_name {
    padding-left: 95px;
}

.table.patient_info .p_age {
    padding-left: 65px;
}

.table.patient_info .p_weight {
    padding-left: 40px;
}

.table.patient_info .p_date {
    padding-left: 30px;
}

.left-container {
    /* padding: 30px 15px 15px 15px; */
    /* background-color: #F0F9FE; */
    margin-right: 35px;
}
.test_details {
    position: relative;
    padding: 20px;
    min-height: 850px; /* Adjust the height as needed */
}

.basic_test_info {
    min-height: 170px;
    margin-top: 60px;
    padding-left: 55px;
}

.examines {
    min-height: 175px;
    margin-top: 25px;
    padding-left: 55px;
}

.advices {
    min-height: 225px;
    margin-top: 25px;
    padding-left: 55px;
}

.basic_test_info h5, .advices h5, .examines h5 {
    font-weight: 400;
}

.basic_test_info ul li, .advices ul li, .examines ul li {
    font-size: 14px;
}

.next_visit {
    min-height: 100px;
    margin-top: 13px;
    padding-left: 55px;
}

.next_visit p {
    /* color:#ff0000; */
    color:#000000;
    font-size: 14px;
    font-weight: 500;
}

.next_visit p:first-child {
    margin-left: 40px;
}

.next_visit p span.visit_days {
    position: relative;
    display: inline-block;
    width: 20%;
    margin-right: 20px;
}

.pl-0 {
    padding-left: 0 !important;
}

.medicine_details {
    padding-top: 55px;
}

.medicine_details ul {
    list-style: none;
    padding-left: 0;
}

.medicine_details ul li h5{
    font-weight: 400;
}

.medicine_details ul li p{
    padding-left: 20px;
    font-size: 14px;
}

</style>